module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAABHCAYAAAA+9NYPAAAAAXNSR0IArs4c6QAAARxJREFUSA1jZCAAZs2aZQ9SwkRAHVx6VCE8KLAxRoMHW6jAxQYweOBuGGUM+xBgJOTD2bNnG4PUsBBS+P//fx6QmgFMuKNW442k0eAZDR6MEBjARMECLFsU//79G8jIyDgjPT39G4bjoAJMqamp94Hsi//+/QvEpQgkDvYM0KT9TExMnEDTLXApBisEWvuPjY1tDdBU2/nz50tgUwwPnsTExA9ADdt+/vwZOnPmTFZ0xXCFIIm0tLSrQCc8BJaJXngVgiSBirYDKTlgA1MbWTHWohnkzl+/fsUC3T379+/f+iANWBWCJIDuNAdSukCn3AHa8h/FjSAFMAAMspNA9jdgSBiCxHAqhGrYAKSVgaEhgdNqqEKGRYsWcYPYAN2aTaWABOz3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow.png
// module id = 27
// module chunks = 0